import React from 'react'

import { useArcadeMigrationFeatureFlag } from '../../ArcadeComponentMigration/ArcadeComponentMigrationProvider'
import ArcadeFieldLabel from './ArcadeFieldLabel'
import MooncakeFieldLabel from './MooncakeFieldLabel'

export type FieldLabelProps = {
  label: string
  space?: string
  tooltip?: React.ReactNode
  children?: React.ReactNode
  htmlFor?: string
  className?: string
}

/**
 * @deprecated Use ArcadeFieldLabel instead
 */
const FieldLabel: React.FC<FieldLabelProps> = ({ label, ...props }) => {
  // using the input feature flag since Input and FieldLabel are used in conjunction
  const shouldUseArcadeFieldLabel = useArcadeMigrationFeatureFlag('input')

  if (shouldUseArcadeFieldLabel) {
    return <ArcadeFieldLabel label={label} {...props} />
  }
  return <MooncakeFieldLabel label={label} {...props} />
}

export default FieldLabel
